export default __webpack_public_path__ + "static/media/founder2.4d847fc4.jpeg";